import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export interface Doctor {
  firstName: string;
  lastName: string;
  npi: string;
  phoneNumber: string;
  faxNumber: string;
  city: string;
  state: string;
  addressLineOne: string;
  addressLineTwo?: string;
  zipCode: string;
  specialty: string;
  practiceAddress: string;
}

export interface PecosCheck {
  isEnrolled: boolean;
  status: string;
}

export async function searchDoctors(
  searchByNpiOrName?: string,
): Promise<Doctor[]> {
  const { data } = await privateAPI.get<ServiceResponse<Doctor[]>>(
    "/doctors/search",
    {
      params: { terms: searchByNpiOrName },
    },
  );

  return data.data;
}

export async function checkPecos(npi: string): Promise<PecosCheck> {
  const { data } = await privateAPI.get<ServiceResponse<PecosCheck>>(
    `/doctors/pecos-check/${npi}`,
  );

  return data.data;
}
